import { Box } from 'ui/box';
import { Stack } from 'ui/stack';

import { Loader } from 'ui/loader';
import TableComponent from 'components/partials/table-component/table-component';
import EmptySpaceContent from 'components/partials/empty-space-content/empty-space-content';

import { useUserActivity } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/hooks/use-user-activity';
import { getUserActivityTableSettings } from 'containers/admin/clients/client/tabs-components/insights-tab/insight-details/tabs/user-activity-tab.config';

interface UserActivityTabProps {
  insightId: string | number | undefined;
}

const renderStatisticItem = (
  label: string,
  count: number,
  total: number
): React.JSX.Element => (
  <Box sx={{ color: 'tokens.gray.600' }}>
    <span className="font-semibold">{label}: </span>
    <span>{count}</span>
    <span>/{total}</span>
  </Box>
);

const UserActivityTab = ({
  insightId,
}: UserActivityTabProps): React.JSX.Element => {
  const { users, loading, error, totalUsers, viewedCount, downloadedCount } =
    useUserActivity({ insightId });

  const columns = getUserActivityTableSettings();

  if (error) {
    return (
      <div className="p-8 text-center text-red-500">
        Error loading user activity. Please try again.
      </div>
    );
  }

  if (!users.length && !loading) {
    return (
      <EmptySpaceContent
        customClass="flex-1"
        text="No users have been assigned yet"
      />
    );
  }

  return (
    <Box sx={{ position: 'relative' }}>
      <Loader loading={loading} backdrop="white" fullScreen={false} />
      <Stack direction="row" sx={{ gap: 1.5, mt: 2.5, mb: 1.5 }}>
        {renderStatisticItem('Viewed', viewedCount, totalUsers)}
        {renderStatisticItem('Downloaded', downloadedCount, totalUsers)}
      </Stack>
      <TableComponent
        columns={columns}
        data={users}
        customHeight="max-h-[500px]"
        pagination={false}
        showingRecordsTextIsOn={false}
        viewByAmountSelectIsOn={false}
        isLoading={loading}
      />
    </Box>
  );
};

export default UserActivityTab;
